<template>
  <th class="text-center" width="5%">
    <slot name="after"></slot>
    {{index + 1}}.
    <slot name="before"></slot>
  </th>
</template>

<script>
export default {
  name: 'w-lp-cell',
  props: {
    index: {
      type: Number,
      required: true
    }
  }
};
</script>